export const camelCase = (string) =>
  string.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_match, char) => char.toUpperCase());

export const humanize = (string) =>
  string
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, (m) => m.toUpperCase());